<template>
    <div>
        <v-dialog persistent v-model="display" width="600">
            <v-card v-if="display == true">
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Impostazione Ip secondari</v-toolbar-title>
                        </v-col>
                        <v-col cols="2">
                            <v-btn small light @click="add">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="save">
                                <v-icon color="success">mdi-check</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container :key="ui_key">
                    <v-row v-for="(ip,i) in ip_list" :key="i" align="center" dense>
                        <v-col cols="1">
                            <v-btn icon @click="moveup(i)">
                                <v-icon color="primary">mdi-arrow-up</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5">
                            <v-text-field :label="'IP ' + (i+2)" v-model="ip.ip" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="Subnet mask" v-model="ip.mask" type="number" :min="1" :max="32" />
                        </v-col>
                        <v-col cols="1" />
                        <v-col cols="2" align="right">
                            <v-btn small light @click="remove(i)">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import IpFormat from './ipformat.js';
export default {
    name : 'DialogIpQuickConnext',
    data(){
        return{
            display : false,
            ip_list : null,
            ui_key : 0
        }
    },
    methods : {
        add(){
            this.ip_list.push({ip:'', mask: 24});
        },
        remove(index){
            this.ip_list.splice(index,1);
        },
        moveup(index){            
            if(index == 0){ return; }
            const previous = this.ip_list[index -1];
            const actual = this.ip_list[index];
            this.ip_list[index -1] = actual;
            this.ip_list[index] = previous;
            //this.ui_key++;
        },
        open(ip_list){
            this.ip_list = ip_list;
            this.display = true;
        },
        save(){
            for(let i=0; i < this.ip_list.length; i++){
                const mask = Number(this.ip_list[i].mask);
                if(!IpFormat.checkIpFormat(this.ip_list[i].ip) || mask <=0 || mask > 32){
                    alert('L\'ip '+ (i+2) + ' ha un formato non corretto');
                    return;
                }
            }
            this.display = false;
        }
    }
}
</script>